import type { FaireProductEntity } from "../../entity_types/product";

export const p_4kyn7eah28: FaireProductEntity = {
  token: "p_4kyn7eah28",
  type: "product",
  name: "Hot Pink Star Eyed Happy Face Slippers Grad Gift Idea",
  brandToken: "b_xkh87elait",
  brandName: "Katydid",
  imageUrl:
    "https://cdn.faire.com/fastly/08e2dd8158d1f0f193bf2d4cdda9886e8376501b9121d50a0c82904972073a5c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea9e6fe4f40309b73df0e8c5d5e0e801b53a57466db24cefec2d21bdb946a4c4.jpeg",
  ],
  priceDollars: 14,
  description:
    "Dive into the enchanting world of comfort and style with our Hot Pink Star-Eyed Happy Face Slippers, exclusively available at Katydid Wholesale. These whimsical slippers bring a burst of vibrant energy to any retail collection, featuring a lively hot pink hue and a cheerful smiley face with starry eyes. Crafted for those who appreciate both comfort and playfulness, these slippers make a stellar addition to your store's offerings.\n\nDesigned with attention to detail, our Star-Eyed Happy Face Slippers combine plush interiors for ultimate coziness with a non-slip sole for stability. Elevate your inventory with these uniquely charming slippers, catering to customers who seek joy in every step. Ensure your store stands out by offering these exclusive slippers that seamlessly blend comfort, quality, and a touch of fun. At Katydid Wholesale, we pride ourselves on delivering products that captivate and delight.\n\nhand wash warm; hang to dry\ns/m fits sizes 6-7, m/l fits sizes 8-9, l fits size 10",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:55.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
